import {json} from '../core/data-source/json.mapper';

export enum NotificationModeRecordNames {
    SMS = 'SMS',
    EMAIL = 'EMAIL'
}

export class NotificationModeRecord {
    @json()
    id: number;

    @json()
    name: string;

    @json()
    enable: boolean;

    @json({
        value: false
    })
    disabled: boolean;

    @json({
        jsonName: 'id',
        skip: true,
        mapper: {
            from: (value: number, jsonData: any) => jsonData.name === NotificationModeRecordNames.SMS
        }
    })
    isSMS: boolean;
}
